import { useState } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { useSuspenseQuery } from '@tanstack/react-query';
import { ChevronDown } from 'lucide-react';
import { adminPeriodsOptions } from '../lib/resources/queries';
import { Card } from '../components/ui/card';
import { EmptyState } from '../components/ui/empty-state';
import { PeriodRow } from './-components/period-row';

export const Route = createFileRoute('/admin/')({
  loader: ({ context: { queryClient } }) => queryClient.ensureQueryData(adminPeriodsOptions()),
  component: AdminOverviewPage,
});

function AdminOverviewPage() {
  const periodsQuery = useSuspenseQuery(adminPeriodsOptions());
  const periods = periodsQuery.data;
  const [expanded, setExpanded] = useState<number | null>(periods[0]?.id ?? null);

  if (periods.length === 0) {
    return (
      <div className="max-w-6xl mx-auto p-8">
        <EmptyState
          icon={ChevronDown}
          title="No periods yet"
          description="Periods auto-create when contractors first interact with the portal."
        />
      </div>
    );
  }

  return (
    <div className="max-w-6xl mx-auto p-8 space-y-3">
      <h1 className="text-[28px] font-bold tracking-tight mb-4">All periods</h1>
      <Card className="overflow-hidden">
        <ul className="divide-y divide-border">
          {periods.map((p) => (
            <PeriodRow
              key={p.id}
              card={p}
              expanded={expanded === p.id}
              onToggle={() => setExpanded(expanded === p.id ? null : p.id)}
            />
          ))}
        </ul>
      </Card>
    </div>
  );
}
